import { useMemo } from 'react';
import DataTable from '../../components/DataTable';
import AvatarName from '../../components/AvatarName';

export default function PlayerList({ players }) {
  const hasMembers = useMemo(() => {
    return players[0] && (players[0].members || []).length;
  }, [players]);

  const columns = useMemo(() => {
    const data = [
      {
        title: '序号',
        dataIndex: 'idx',
        key: 'idx',
        align: 'center',
        width: 60,
      },
      { title: '编号', dataIndex: 'playerId', key: 'playerId' },
      {
        title: '姓名',
        dataIndex: 'name',
        key: 'name',
        render: (t) => <AvatarName name={t} />,
      },
    ];
    if (hasMembers) {
      data.push({
        title: '队友',
        dataIndex: 'members',
        key: 'members',
        render: (v) => (v || []).map((p) => p.name).join(','),
      });
    }
    return data;
  }, [hasMembers]);
  return (
    <DataTable
      rowKey="playerId"
      columns={columns}
      list={players.map((p, index) => ({ ...p, idx: index + 1 }))}
      pagination={false}
    />
  );
}
